module.exports = __webpack_public_path__ + "static/media/ic-arrow-circle.b6128541.svg";